import {Component, OnInit, ChangeDetectorRef, Input} from '@angular/core';
import {Subscription} from 'rxjs';
import {SharedService} from '@core/util-services/shared.service';
import {environment} from '@env/environment';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';

@Component({
    selector: 'savvy-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent implements OnInit {
    environment = environment;
    currentStep = 1;
    displayStep = 1;
    progressPercent = 0;
    numSteps = 4;
    subscription = new Subscription();
	checkIconUrl: string = `${this.environment.s3Url}images/${this.environment.institutionId}/icon-check-white.png`;
    currentStepTitle = '';

    private readonly routeConfig = [
        { id: 1, title: 'Product Selection', url: '/' },
        { id: 1.5, title: 'Identity Verification', url: '/identity-verification' },
        { id: 1.5, title: 'Personal Information', url: '/add-personal-information' },
        { id: 1.5, title: 'Personal Information', url: '/consent' },
        { id: 1.5, title: 'Add Income', url: '/add-income' },
        { id: 1.5, title: 'Eligibility', url: '/set-eligibility' },
        { id: 1.5, title:  'Agreement', url: '/agreement'},
        { id: 1.5, title: 'Additional Details', url: '/review' },
        { id: 2.5, title: 'Congrats', url: '/provision/decision-page' },
        { id: 2.5, title: 'E-Signature', url: '/provision/esign' },
        { id: 2.5, title: 'Verification', url: '/provision/kyc' },
        { id: 2.5, title: 'Upload Documents', url: '/provision/upload-docs' },
        { id: 3, title: 'Provision', url: '/provision' },
        { id: 3, title: 'Funding', url: '/provision/payment' },
        { id: 3.5, title: 'Direct Deposit', url: '/provision/direct-deposit' },
        { id: 3.5, title: 'Pre-registration', url: '/provision/pre-registration' },
        { id: 3.5, title: 'Pre-registration', url: '/provision/pre-registration-url' },
        { id: 4, title: 'Thank You', url: '/thankyou' },
        { id: 4, title: 'Thank You', url: '/provision/thankyou' },
        { id: 4, title: 'Congratulations', url: '/provision/cross-sell' },
    ];

    mainSteps = [
        { id: 1, title: 'Product Selection' },
        { id: 2, title: 'Congrats' },
        { id: 3, title: 'Provision' },
        { id: 4, title: 'Thank You' },
    ];
    @Input() hideTitleOnLanding: boolean = false;


    constructor(private sharedService: SharedService,
                private cdr: ChangeDetectorRef,
                private router: Router
            ) {

    }

   ngOnInit() {
    if (this.sharedService.stepperStep) {
        this.sharedService.stepperStep.subscribe(step => {
            this.setStep(step);
        });
    }
    this.router.events
        .pipe(filter(event => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
            this.updateStepFromUrl(event.urlAfterRedirects);
        });
    this.updateStepFromUrl(this.router.url);
}


    isStepDone(stepIndex: number): boolean {
        return Math.floor(this.currentStep) > stepIndex;
    }
    
    isStepEdit(stepIndex: number): boolean {
        return this.currentStep > stepIndex && this.currentStep < stepIndex+1;
    }
    
    isStepActive(stepIndex: number): boolean {
        return Math.floor(this.currentStep) === stepIndex;
    }

    // SR-only: step is "done" as soon as currentStep passes it (including sub-steps like 1.5)
    isStepDoneSR(stepIndex: number): boolean {
        return this.currentStep > stepIndex;
    }

    // SR-only: step is "current" only on its exact landing page, not during sub-steps
    isStepActiveSR(stepIndex: number): boolean {
        return this.currentStep === stepIndex;
    }

    updateStepFromUrl(url: string) {
        const cleanUrl = url.split('?')[0];
        const sortedRoutes = [...this.routeConfig].sort(
            (a, b) => b.url.length - a.url.length
        );

        const matched = sortedRoutes.find(r =>
            cleanUrl.startsWith(r.url)
        );

        if (matched) {
            this.setStep(matched.id, matched.title);
        }
    }

    get showStepTitle(): boolean {
    const hide = this.hideTitleOnLanding ?? false;
    return !(hide && this.currentStep === 1);
}
    
    setStep(selectedStep: number, title?: string){
        this.currentStep = selectedStep;
        this.displayStep = Math.floor(this.currentStep);
        if(title){
        this.currentStepTitle = title;}
        this.cdr.detectChanges();
        /*const stepper = document.getElementById('stepper');
        if (stepper) {
            const steps = stepper.getElementsByClassName('step');

            Array.from(steps).forEach((step, index) => {
                const stepNum = index + 1;
                if (stepNum === this.currentStep) {
                    this.addClass(step, 'editing');
                } else {
                    this.removeClass(step, 'editing');
                }
                if (stepNum < this.currentStep) {
                    this.addClass(step, 'done');
                } else {
                    this.removeClass(step, 'done');
                }
            });

            this.cdr.detectChanges();
        }*/
    }

    /*hasClass(elem, className) {
        return new RegExp(' ' + className + ' ').test(' ' + elem.className + ' ');
    }

    addClass(elem, className) {
        if (!this.hasClass(elem, className)) {
            elem.className += ' ' + className;
        }
    }

    removeClass(elem, className) {
        let newClass = ' ' + elem.className.replace( /[\t\r\n]/g, ' ') + ' ';
        if (this.hasClass(elem, className)) {
            while (newClass.indexOf(' ' + className + ' ') >= 0 ) {
                newClass = newClass.replace(' ' + className + ' ', ' ');
            }
            elem.className = newClass.replace(/^\s+|\s+$/g, '');
        }
    }*/
}
